<template lang="pug">

  section.Sample(v-if="data")

    SampleCover(:item="data" @toggleMoreInfos="toggleMoreInfos")

    transition(name="fade" mode="out-in")
      SampleGeographicInfo(:geologicType="data.geologicType" :parent="data.parent" :type="data.type" :withButton="hasContent")

    //- transition(name="fade")

    ScrollTop

</template>

<script>

import SampleModel from '@/models/SampleModel'
import SampleCover from '@/components/SampleCover'
import SampleGeographicInfo from '@/components/SampleGeographicInfo'
import ScrollTop from '@/components/common/ScrollTop'
import { TweenLite, ScrollToPlugin, Power4 } from 'gsap/all'
const plugins = [ScrollToPlugin]

export default {
  name: 'sample',
  props: ['uuid', 'type'],
  components: { SampleCover, SampleGeographicInfo, ScrollTop },
  data () {
    return {
      data: null,
      meta: null,
      openDetails: false,
      displayInfos: false
    }
  },
  metaInfo () {
    return this.meta
  },
  methods: {
    fetchData () {
      this.$api.getSample(this.$i18n.locale, this.type, this.uuid)
        .then(response => {
          this.data = new SampleModel(response.data)

        // this.data.photos = this.data.relationships.photos.data.map((p) => {
        //   const image = this.$tools.getRelationShips(response, p.id)
        //   return this.$tools.getRelationShips(response, image.relationships.field_image.data.id)
        // })

        // this.data.drawer = this.$tools.getRelationShips(response, this.data.relationships.drawer.data.id)
        // this.data.collection = this.$tools.getRelationShips(response, this.data.drawer.relationships.collection.data.id)
        })
    },
    fetchMeta () {
      this.$api.getSampleMetaTag(this.$i18n.locale, this.uuid, true)
        .then(response => {
          this.meta = this.$metatag.formateMeta(response.data)
        })
    },
    // classOpened (value) {
    //   console.log(this.displayInfos, this.openDetails, this.hasContent)
    //   this.openDetails = value
    // },
    toggleMoreInfos (state) {
      this.displayInfos = state

      // this.openDetails = false
    }
  },
  watch: {
    // call again the method if the route changes
    $route (to, from) {
      if (to.path != from.path) {
        TweenLite.to(document.body.querySelector('.MainContainer'), 1, { scrollTo: 0,
          ease: Power4.easeOut,
          onComplete: () => {
            // this.displayInfos = false
            this.$nextTick(() => {
              this.fetchData()
              this.fetchMeta()
            })
          } })
      }
    }
  },
  computed: {
    hasContent () {
      if (!this.data.geologicType) return false

      let p = []
      if (Array.isArray(this.data.geologicType)) {
        let a = this.data.geologicType.find((g) => g.paragraphs != null)
        if (Array.isArray(a)) {
          for (let i = 0; i < a.length; i++) {
            p = p.concat(a[i].paragraphs)
          }
        } else { p = a.paragraphs }
      } else {
        p = this.data.geologicType.paragraphs
      }
      return !!(p && p.length > 0)
    }
  },
  created () {
    this.fetchData()
    this.fetchMeta()
  },
  mounted () {
    this.$parallax.set(this.$refs.cover, { opacity: 0 }, { opacity: 0 }, { opacity: 1 }, null, -0.8)
  },
  beforeDestroy () {
    this.$parallax.remove(this.$refs.cover)
  }
}

</script>

<style lang="stylus" scoped>

.Sample

  height 100%
  // overflow hidden

  &_is-open

    overflow auto
    height unset

</style>
